import PageSeo from "@/components/PageSeo";
import CtaBannerSection from "@/components/sections/CtaBannerSection";
import FeatureListSection from "@/components/sections/FeatureListSection";
import HeroSection from "@/components/sections/HeroSection";
import NewsletterSignupSection from "@/components/sections/NewsletterSignupSection";
import ProfileSection from "@/components/sections/ProfileSection";
import StatementSection from "@/components/sections/StatementSection";
import VideoShowcaseSection from "@/components/sections/VideoShowcaseSection";
import WorkshopsListSection from "@/components/sections/WorkshopsListSection";
import { homePageContent } from "@/content/pages/homePage";

const HomePage = () => {
  return (
    <div className="pt-16 md:pt-20">
      <PageSeo seo={homePageContent.seo} />
      <HeroSection content={homePageContent.hero} dataTestId="hero-section" />
      <StatementSection content={homePageContent.brandIntro} dataTestId="brand-intro" />
      <FeatureListSection content={homePageContent.pillarsSection} dataTestId="pillars-section" className="bg-muted/50" />
      <NewsletterSignupSection content={homePageContent.newsletterSection} dataTestId="newsletter-section" />
      <WorkshopsListSection content={homePageContent.workshopsSection} dataTestId="workshop-section" className="bg-muted/50" />
      <VideoShowcaseSection content={homePageContent.youtubeSection} dataTestId="youtube-section" />
      <ProfileSection content={homePageContent.instructorSection} dataTestId="instructor-section" className="bg-muted/50" />
      <CtaBannerSection content={homePageContent.finalCta} dataTestId="cta-section" />
    </div>
  );
};

export default HomePage;
